import { Line, Polygon, Svg } from "@react-pdf/renderer";

type LogoWireframeProps = Omit<Svg["props"], "viewBox">;

const LogoWireframe: React.FC<LogoWireframeProps> = (props) => {
  return (
    <Svg viewBox="0 0 1318.5 1141.86" {...props}>
      <Polygon
        opacity={0.02}
        fill="#ffffff"
        points="331.94 570.93 4.62 570.93 168.28 854.39 331.94 1137.86 495.59 854.39 331.94 570.93"
      />
      <Polygon
        opacity={0.02}
        fill="#ffffff"
        points="331.94 4 168.28 287.46 4.62 570.93 331.94 570.93 495.59 287.46 331.94 4"
      />
      <Polygon
        opacity={0.02}
        fill="#ffffff"
        points="659.25 4 331.94 4 495.59 287.46 822.91 287.46 986.57 4 659.25 4"
      />
      <Polygon
        opacity={0.02}
        fill="#ffffff"
        points="1150.23 287.46 986.57 4 822.91 287.46 986.57 570.93 1313.89 570.93 1150.23 287.46"
      />
      <Polygon
        opacity={0.02}
        fill="#ffffff"
        points="986.57 570.93 822.91 854.39 986.57 1137.86 1150.23 854.39 1313.89 570.93 986.57 570.93"
      />
      <Polygon
        opacity={0.02}
        fill="#ffffff"
        points="822.91 854.39 495.59 854.39 331.94 1137.86 659.25 1137.86 986.57 1137.86 822.91 854.39"
      />
      <Polygon
        fill="#1e929d"
        opacity={0.18}
        points="495.59 287.46 331.94 570.93 659.25 570.93 495.59 287.46"
      />
      <Polygon
        fill="#1e929d"
        opacity={0.5}
        points="659.25 570.93 495.59 854.39 822.91 854.39 659.25 570.93"
      />
      <Polygon
        fill="#1e929d"
        opacity={0.15}
        points="495.59 854.39 331.94 570.93 659.25 570.93 495.59 854.39"
      />
      <Polygon
        fill="#1e929d"
        opacity={0.85}
        points="822.91 287.46 659.25 570.93 986.57 570.93 822.91 287.46"
      />
      <Polygon
        fill="#1e929d"
        opacity={0.35}
        points="822.91 854.39 659.25 570.93 986.57 570.93 822.91 854.39"
      />
      <Polygon
        fill="#1e929d"
        opacity={0.75}
        points="659.25 570.93 495.59 287.46 822.91 287.46 659.25 570.93"
      />
      <Polygon
        fill="none"
        stroke="#1e929d"
        strokeWidth={8}
        points="331.94 4 4.62 570.93 331.94 1137.86 986.57 1137.86 1313.89 570.93 986.57 4 331.94 4"
      />
      <Line
        fill="none"
        stroke="#1e929d"
        strokeWidth={8}
        x1="331.94"
        y1="4"
        x2="986.57"
        y2="1137.86"
      />
      <Line
        fill="none"
        stroke="#1e929d"
        strokeWidth={8}
        x1="986.57"
        y1="4"
        x2="331.94"
        y2="1137.86"
      />
      <Line
        fill="none"
        stroke="#1e929d"
        strokeWidth={8}
        x1="4.62"
        y1="570.93"
        x2="1313.89"
        y2="570.93"
      />
    </Svg>
  );
};

export default LogoWireframe;
